import React, { useState, useEffect } from "react";

const CatalogueNavbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return (
    <nav
      style={{
        transition: "background-color 0.5s ease-in-out, color 0.5s ease-in-out",
      }}
      className={`fixed top-0 pt-1 pb-1 left-0 right-0 w-full z-10 ${
        isScrolled ? "bg-black text-white" : "bg-transparent text-black"
      }`}
    >
      <div className="flex  text-white flex-col items-center w-full">
        {/* Top menu row */}
        <div className="hidden md:flex justify-between items-center w-full px-4 pt-2 z-50">
          <div className="flex">
            <a href="/Garments" className="mr-4 hover:underline">
              Garments
            </a>
            <a href="/Fabrics" className="hover:underline">
              Fabrics
            </a>
          </div>
          <div className="flex">
            <a href="/Catalogue" className="mr-4 hover:underline">
              Catalogue
            </a>
            <a href="/Catalogue#ContactUs" className="hover:underline">
              Contact Us
            </a>
          </div>
        </div>
        {/* Mobile Navigation Header */}
        <div className="md:hidden z-20 flex justify-end items-center w-full px-2  pt-2 ">
          <button onClick={() => setIsMenuOpen(true)}>
            {/* Hamburger Icon in white with aesthetic spacing */}
            {/* <svg
              className="w-8 h-8 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg> */}
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              {/* Hamburger icon changes to "X" when menu is open */}
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16m-7 6h7"
              ></path>
            </svg>
          </button>
        </div>

        {/* Mobile Sliding Sidemenu */}
        <div
          className={`fixed top-0 right-0 h-screen w-[40%] bg-black text-white transform transition-transform duration-300 z-50
        ${
          isMenuOpen ? "translate-x-0" : "translate-x-full"
        } rounded-tl-lg rounded-bl-lg`}
        >
          {/* Close Button */}
          <div className="flex justify-end p-4">
            <button onClick={() => setIsMenuOpen(false)}>
              <svg
                className="w-6 h-6 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          {/* Menu List */}
          <div className="flex flex-col items-center justify-center space-y-6 p-4">
            <a
              href="/Garments"
              onClick={() => setIsMenuOpen(false)}
              className="hover:underline"
            >
              Garments
            </a>
            <a
              href="/Fabrics"
              onClick={() => setIsMenuOpen(false)}
              className="hover:underline"
            >
              Fabrics
            </a>
            <a
              href="/Catalogue"
              onClick={() => setIsMenuOpen(false)}
              className="hover:underline"
            >
              Catalogue
            </a>
            <a
              href="/Catalogue#ContactUs"
              onClick={() => setIsMenuOpen(false)}
              className="hover:underline"
            >
              Contact Us
            </a>
          </div>
        </div>
        {/* Logo and line */}
        <div className="flex items-center mb-2 justify-center w-full -mt-4">
          <div className="flex-grow border-t border-gray-400"></div>
          <img
            src="/NavCatLogo.png"
            alt="Catalogue Logo"
            className="h-12 w-auto mx-4"
          />
          <div className="flex-grow border-t border-gray-400"></div>
        </div>
      </div>
    </nav>
  );
};

export default CatalogueNavbar;
